import React, { useEffect, useState } from "react";

const Block = ({
  row,
  col,
  updatePattern,
  beadNumber,
  disable,
  pattern,
  paletteColor,
  defaultColor,
}) => {
  const [color, setColor] = useState(defaultColor);

  const handleMouseOver = (e) => {
    if (e.buttons === 1) {
      // Always use the current paletteColor prop directly for immediate painting
      e.target.style.backgroundColor = paletteColor;
      updatePattern({ bead: beadNumber, color: paletteColor });
    }
  };

  useEffect(() => {
    setColor(pattern[beadNumber - 1]);
  }, [pattern, beadNumber]);

  const changeColor = (beadNumber) => {
    updatePattern({ bead: beadNumber, color: paletteColor });
  };

  return (
    <td>
      <div
        onMouseMove={handleMouseOver}
        onClick={() => changeColor(beadNumber)}
        id={`row-${row} col-${col} bead-${beadNumber}`}
        style={{ backgroundColor: color || defaultColor }}
        className={`bead ${disable ? "disabled" : ""}`}
      >
        {/* {beadNumber} */}
      </div>
    </td>
  );
};

export default Block;
